module.exports = __webpack_public_path__ + "img/modelos-tecnicos-inativos.d4a5fd66.svg";